module.exports = __webpack_public_path__ + "img/logo-woco-vanalckmaer-color.15432453.png";